import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { IntlProvider } from "react-intl";
import { SkeletonTheme } from "react-loading-skeleton";
import "react-phone-input-2/lib/style.css";
import { Provider } from "react-redux";
import "./App.css";
import { LOCALES } from "./i18n/locales";
import { messages } from "./i18n/messages";
import { AuthInit, AuthProvider } from "./modules/auth/components/AuthInit";
import { AppRoutes } from "./routing/AppRoutes";
import store from "./setup/Store";

function App() {
  function getInitialLocal() {
    const savedLocale = localStorage.getItem("locale");
    return savedLocale || LOCALES.ENGLISH;
  }

  return (
    <Provider store={store}>
      <IntlProvider
        messages={messages[getInitialLocal()]}
        locale={getInitialLocal()}
        defaultLocale={LOCALES.ENGLISH}
      >
        <AuthProvider>
          <AuthInit>
            <SkeletonTheme baseColor="#202020" highlightColor="#444">
              <AppRoutes />
            </SkeletonTheme>
          </AuthInit>
        </AuthProvider>
      </IntlProvider>
    </Provider>
  );
}

export default App;
